module.exports = __webpack_public_path__ + "img/antonio-passarella.aa030b4c.jpg";